import { TableColumn } from '../types/column'
import { TableData } from '../types/data'
import { getColumnsIds } from './getColumnsIds'

export const getNewColumnsIds = <T extends TableData>(columns: TableColumn<T>[]): string[] =>
  getColumnsIds(columns.filter(({ hidden, isNewColumn }) => !!hidden && !!isNewColumn))
